import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmployees, addEmployee } from '../../store/slices/employeeSlice';
import { useParams } from 'react-router-dom';

const AdminEmployees = () => {
    const dispatch = useDispatch();
    const { employees, loading, error } = useSelector((state) => state.employees);
    const [employeeData, setEmployeeData] = useState({ name: '', email: '', phone: '' });
    const { slug } = useParams();

    useEffect(() => {
        dispatch(fetchEmployees());
    }, [dispatch, slug]);

    const handleInputChange = (e) => {
        setEmployeeData({ ...employeeData, [e.target.name]: e.target.value });
    };

    const handleAddEmployee = (e) => {
        e.preventDefault();
        dispatch(addEmployee({slug, employeeData}));
        setEmployeeData({ name: '', email: '', phone: '' });
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold">Gestionar Empleados</h1>

            <form onSubmit={handleAddEmployee} className="mt-6">
                <h2 className="text-2xl font-semibold mb-4">Agregar Empleado</h2>
                <div className="mb-4">
                    <label className="block">Nombre</label>
                    <input
                        type="text"
                        name="name"
                        value={employeeData.name}
                        onChange={handleInputChange}
                        className="border px-4 py-2 w-full"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block">Email</label>
                    <input
                        type="email"
                        name="email"
                        value={employeeData.email}
                        onChange={handleInputChange}
                        className="border px-4 py-2 w-full"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block">Teléfono</label>
                    <input
                        type="text"
                        name="phone"
                        value={employeeData.phone}
                        onChange={handleInputChange}
                        className="border px-4 py-2 w-full"
                        required
                    />
                </div>
                <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
                    Agregar Empleado
                </button>
            </form>

            <h2 className="text-2xl font-semibold mt-8">Lista de Empleados</h2>
            {loading ? (
                <p>Cargando empleados...</p>
            ) : error ? (
                 <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                <strong>Error:</strong>{' '}
                {typeof error === 'object' ? error.message || JSON.stringify(error) : error}
            </div>
            ) : (
                <table className="min-w-full mt-4">
                    <thead>
                        <tr>
                            <th className="px-4 py-2">Nombre</th>
                            <th className="px-4 py-2">Email</th>
                            <th className="px-4 py-2">Teléfono</th>
                            {/* Agrega acciones para editar y eliminar */}
                        </tr>
                    </thead>
                    <tbody>
                        {employees.map((employee) => (
                            <tr key={employee._id}>
                                <td className="border px-4 py-2">{employee.name}</td>
                                <td className="border px-4 py-2">{employee.email}</td>
                                <td className="border px-4 py-2">{employee.phone}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default AdminEmployees;
